import * as defaultImport from "@splunk/ui-utils/format";
export * from "@splunk/ui-utils/format";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
